export default __webpack_public_path__ + "static/AppInterview4-c6130c92054009aa172d4d5c9436d67d.png";